import React from "react";

function AppBar() {
  return (
    <div className="app-bar">
      <div className="app-bar__heading">Portfolio</div>
      <div className="app-bar__list-box">
        <ul className="app-bar__list u-margin-right-small">
          <a href="#about">
            <li>About</li>
          </a>
          <a href="#skills">
            <li>Skills</li>
          </a>
          <a href="#work">
            <li>Work</li>
          </a>
          <a href="#education">
            <li>Education</li>
          </a>
        </ul>
        <a className="btn-primary" href="#contact">
          Contact
        </a>
      </div>
    </div>
  );
}

export default AppBar;
